import React from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import CredoraIcon from "./CredoraIcon";
import { CREDORA_MODAL_CONTAINER } from "./credoraModalUtils";

const TONE_META = {
  primary: { icon: "edit", confirmColor: "primary" },
  danger: { icon: "attention", confirmColor: "danger" },
  warning: { icon: "clock", confirmColor: "warning" },
  success: { icon: "check", confirmColor: "success" },
};

/**
 * Presentational prompt dialog with text input. Prefer useConfirmDialog().prompt() app-wide.
 */
const CredoraPromptDialog = ({
  isOpen,
  toggle,
  title,
  message,
  label,
  placeholder = "",
  inputValue,
  onInputChange,
  confirmLabel = "Submit",
  cancelLabel = "Cancel",
  tone = "primary",
  loading = false,
  error = "",
  required = false,
  multiline = false,
  rows = 3,
  onConfirm,
}) => {
  const meta = TONE_META[tone] || TONE_META.primary;

  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? undefined : toggle}
      centered
      className="credora-confirm-dialog credora-prompt-dialog"
      container={CREDORA_MODAL_CONTAINER}
    >
      <ModalHeader toggle={loading ? undefined : toggle}>{title}</ModalHeader>
      <ModalBody>
        <div className="credora-confirm-dialog__body">
          <span className={`credora-confirm-dialog__icon credora-confirm-dialog__icon--${tone}`}>
            <CredoraIcon name={meta.icon} size={22} iconClassName="svg-stroke" />
          </span>
          {message ? <p className="credora-confirm-dialog__message mb-0">{message}</p> : null}
        </div>
        <FormGroup className="credora-prompt-dialog__field mb-0 mt-3">
          <Label for="credora-prompt-dialog-input">
            {label}
            {required ? <span className="text-danger"> *</span> : null}
          </Label>
          <Input
            id="credora-prompt-dialog-input"
            type={multiline ? "textarea" : "text"}
            rows={multiline ? rows : undefined}
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder={placeholder}
            disabled={loading}
            autoFocus
          />
        </FormGroup>
        {error ? <p className="credora-confirm-dialog__error mb-0 mt-3">{error}</p> : null}
      </ModalBody>
      <ModalFooter>
        <Button color="light" className="border" onClick={toggle} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button color={meta.confirmColor} onClick={onConfirm} disabled={loading}>
          {loading ? <Spinner size="sm" /> : confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CredoraPromptDialog;
